'use client';
import React, { useState } from 'react';
import DogMemoryTimeline from './DogMemoryTimeline';
import DogAchievements from './DogAchievements';
import DogCertificates from './DogCertificates';
import DogGuestbook from './DogGuestbook';
import DogPortraitGallery from './DogPortraitGallery';

const TABS = [
  { id: 'timeline', label: '📅 Timeline' },
  { id: 'achievements', label: '🏆 Achievements' },
  { id: 'certificates', label: '🎖 Certificates' },
  { id: 'portraits', label: '🎨 Portraits' },
  { id: 'guestbook', label: '📖 Guestbook' },
];

export default function DogProfileTabs() {
  const [activeTab, setActiveTab] = useState('timeline');

  return (
    <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 py-8">
      {/* Tab bar */}
      <div className="flex gap-1 bg-muted p-1 rounded-xl mb-8 overflow-x-auto scrollbar-thin">
        {TABS?.map((tab) => (
          <button
            key={`tab-${tab?.id}`}
            onClick={() => setActiveTab(tab?.id)}
            className={`flex-1 min-w-max px-4 py-2 rounded-lg text-sm font-600 transition-all duration-150 whitespace-nowrap
              ${activeTab === tab?.id
                ? 'bg-card text-foreground shadow-card'
                : 'text-muted-foreground hover:text-foreground'}`}
          >
            {tab?.label}
          </button>
        ))}
      </div>
      {/* Tab content */}
      <div className="fade-in">
        {activeTab === 'timeline' && <DogMemoryTimeline />}
        {activeTab === 'achievements' && <DogAchievements />}
        {activeTab === 'certificates' && <DogCertificates />}
        {activeTab === 'portraits' && <DogPortraitGallery />}
        {activeTab === 'guestbook' && <DogGuestbook />}
      </div>
    </div>
  );
}